const LEGACY_TAB_MAP: Record<number, string> = {
  0: 'general',
  1: 'jobs',
  2: 'appointments',
  3: 'tasks',
  4: 'items',
  5: 'photos',
  6: 'files',
};

export function resolveSideviewTabName(tab?: string | number): string {
  if (typeof tab === 'number') {
    return LEGACY_TAB_MAP[tab] || 'general';
  }

  return tab || 'general';
}
